<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="message.type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <div class="accordion p-3" role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.accordion-1
                variant="neutral"
                class="text-left"
                >Search Transaction Criteria
                <span class="when-opened ml-3">
                  <i class="fa fa-arrow-down" />
                </span>
                <span class="when-closed ml-3">
                  <i class="fa fa-arrow-right" />
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="mb-3 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    Brand
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="BrandCodeModel"
                      :options="brandCodeOption"
                      class="mx-input"
                    ></b-form-select>
                  </div>
                  <label class="col-sm-2 col-form-label form-control-label">
                    Is Approve
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="IsApproveModel"
                      :options="IsApproveOption"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                </div>                
                <div class="mb-4 row">
                  <label class="col-sm-2 col-form-label form-control-label">
                    query by
                  </label>
                  <div class="col-sm-2">
                    <b-form-select
                      id="input-3"
                      v-model="PropertyFilterModel"
                      :options="PropertyFilterList"
                      class="mx-input"
                      required
                    ></b-form-select>
                  </div>
                  <label
                    class="col-form-label form-control-label text-sm pl-0"
                    >{{ ConditionFilterModel }}</label
                  >
                  <div class="col-sm-4 ml-0">
                    <input
                      v-model="ValueFilterModel"
                      class="form-control mx-input"
                    />
                  </div>
                </div>
                <div class="mt-3 row">
                  <div class="col-sm-2 col-form-label form-control-label"></div>
                  <button
                    v-on:click="onSearchFilter"
                    class="btn btn-warning ml-3"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button
                    v-on:click="onResetFilter"
                    class="btn btn-neutral ml-2"
                  >
                    <i class="fa fa-times"></i> reset query
                  </button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @on-all-select-rows="onSelectAllRow"
        >
        <template slot="action_button" slot-scope="props">
          <button
              v-on:click="updateStatusRaffleEventWinner(props.cell_value, 1)"
              class="btn btn-primary ml-2"
              :disabled="disableApproveRejectButton()"
            >
            Approve
            </button>
            <button
              v-on:click="updateStatusRaffleEventWinner(props.cell_value, 0)"
              :disabled="disableApproveRejectButton()"
              class="btn btn-danger ml-2"
            >
            Reject
            </button>
        </template>
        </vue-bootstrap4-table>
        <div class="overflow-auto mt-3">
          <nav>
            <ul class="pagination b-pagination justify-content-center">
              <li class="col-12 p-0 pl-2">
                <label class="ml-2">Go to page: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="currentPage"
                  :options="arrayPages()"
                  required
                ></b-form-select>
                <b-button
                  v-if="currentPage != 1"
                  v-on:click="onLoadData(currentPage - 1)"
                  class="ml-3 mr-1 btn-sm btn-neutral"
                >
                  <i class="fa fa-less-than"></i>
                </b-button>
                <b-button
                  v-if="currentPage != totalPages"
                  v-on:click="onLoadData(currentPage + 1)"
                  class="ml-1 mr-3 btn-sm btn-neutral"
                >
                  <i class="fa fa-greater-than"></i>
                </b-button>

                <label class="ml-2">Show rows: </label>
                <b-form-select
                  size="sm"
                  class="col-1 ml-2 mr-2"
                  v-model="itemPerPage"
                  :options="ItemPerPageList"
                  required
                ></b-form-select>
                <label
                  >{{ itemPerPage * currentPage - itemPerPage + 1 }} -
                  {{
                    currentPage == totalPages
                      ? totalItems
                      : itemPerPage * currentPage
                  }}
                  of {{ totalItems }}
                </label>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import "vue2-datepicker/index.css";
import api_loyalty from "../api/api";

export default {
  name: "configList",
  data() {
    return {
      is_allowed_approve: false,
      totalItems: 0,
      totalPages: 0,
      isCompletedLoadAllItems: false,
      itemPerPage: 50,
      ItemPerPageList: [50, 100, 500, 1000, 5000],
      currentPage: 1,
      BrandCodeModel: "PHFortune",
      IsApproveModel: "0",
      showLoadButton: true,
      timeFilter: [],
      filter: {
        brand_code: "",
        is_approve: "",
      },
      allRaffleEventWinner: [],
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      IsApproveOption: [
        { text: "True", value: "1" },
        { text: "False", value: "0" },
      ],
      titlePopup: "Create",
      message: null,
      RaffleEventWinnerModel: {
        id: "",
        brandCode: "",
        raffleEventId: "",
        raffleName: "",
        profileId: "",
        isApprove: 0,
        raffleStartDate: "",
        raffleEndDate: "",
      },
      showModalCreate: false,
      showModalDetail: false,
      ValueFilterModel: "",
      PropertyFilterModel: "",
      ConditionFilterModel: "is",
      PropertyFilterList: [
        { text: "Raffle Event Id", value: "raffle_id" },
        { text: "Raffle Event Name", value: "raffle_name" },
      ],
      allMerchants: [],
      rows: [],
      columns: [
        {
          label: "Action",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand Code",
          name: "brandCode",
          row_text_alignment: "text-left",
        },
        {
          label: "Raffle Event Id",
          name: "raffleEventId",
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Raffle Event Name",
          name: "raffleEventName",
          sort: true,
        },
        {
          label: "Profile Id",
          name: "profileId",
          sort: true,
        },
        {
          label: "Is Approve",
          name: "isApproved",
          sort: true,
        },
        {
          label: "Raffle Date",
          name: "raffleDate",
          sort: true,
        },
        {
          label: "Prize Id",
          name: "prizeId",
          sort: true,
        },
        {
          label: "Prize Name",
          name: "prizeName",
          sort: true,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 8,
        per_page: this.itemPerPage ? this.itemPerPage : 50,
        checkbox_rows: false,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: true,
        card_mode: false,
        selected_rows_info: true,
        global_search: {
          visibility: false,
        },
        show_refresh_button: false,
        show_reset_button: false,
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.mappingRole();
    let momNow = this.$moment(new Date().toUTCString());
    let filterEndDate = momNow.format("YYYY-MM-DD");
    let filterStartDate = momNow.add(-1, "months").format("YYYY-MM-DD");
    this.timeFilter.push(filterStartDate);
    this.timeFilter.push(filterEndDate);
    this.filter.start_date = filterStartDate;
    this.filter.end_date = filterEndDate;
    this.DateRangeModel = {
      start_date: filterStartDate,
      end_date: filterEndDate,
    };
    this.onLoadData(this.BrandCodeModel, this.IsApproveModel, this.filter);
    this.selectedItems.push(this.RaffleEventWinnerModel);
  },
  methods: {
    arrayPages() {
      var result = [];
      for (let index = 0; index < this.totalPages; index++) {
        result.push({ text: index + 1, value: index + 1 });
      }
      return result;
    },
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('raffleeventwinner')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('raffleeventwinner')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }
    },
    updateStatusRaffleEventWinner(id, status){
      api_loyalty
        .UpdateStatusRaffleEventWinner(this.BrandCodeModel, id, status)
        .then((data) => {
          if(data.isSuccess){
            this.message = {
              message: "Update Status successful.",
              type: "success",
            };
          }else{
            this.message = {
              message: "Update Status Failed.",
              type: "danger",
            };
          }
          this.onLoadData(this.BrandCodeModel, this.RaffleEventWinnerModel.isApprove);
        })
        .catch((e) => {
          console.log(e);
          this.message = {
            message: "Update Failed." ,
            type: "danger",
          };
        });
    },
    onResetFilter() {
      this.onLoadData(this.BrandCodeModel, this.RaffleEventWinnerModel.isApprove);
      this.ValueFilterModel = "";
      this.PropertyFilterModel = "id";
      this.ConditionFilterModel = "is";
    },
    onSearchFilter() {
      this.filter = {
        brand_code: this.BrandCodeModel,
        start_date: this.DateRangeModel.start_date,
        end_date: this.DateRangeModel.end_date,
      };
      switch (this.PropertyFilterModel) {
        case "raffle_id":
          this.filter.raffle_id = this.ValueFilterModel;
          break;
        case "raffle_name":
          this.filter.raffle_name = this.ValueFilterModel;
          break;
        default:
          break;
      }
      this.onLoadData(this.BrandCodeModel, this.IsApproveModel, this.filter);
    },
    onDateFilterSubmit(value) {
      let momStart = this.$moment(new Date(value[0])).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(value[1])).format("YYYY-MM-DD");
      this.filter.start_date = momStart;
      this.filter.end_date = momEnd;
      this.DateRangeModel = {
        start_date: momStart,
        end_date: momEnd,
      };
    },
    async onLoadData(brandCode, isApproved, filter) {
      api_loyalty
        .GetAllRaffleEventWinner(brandCode, isApproved, filter)
        .then((data) => {
          try {
            if(data.isSuccess)
            {
              this.rows = data.data;
              this.allRaffleEventWinner = data.data;
            }
          } catch (e) {
            console.log(e);
          }
      });
    },
    onSelectAllRow(payload) {
      this.selectedItems = payload.selected_items;
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (
        payload.selected_items.length > 1 ||
        payload.selected_items.length == 0
      ) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.RaffleEventWinnerModel = this.allTransaction.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.showModalCreate = true;
      this.titlePopup = "Details";
    },
    previewContestImage(data){
      if(data){
        //window.open(data.s3_url, '_blank').focus();
        var newWindow = window.open("",'_blank');
        newWindow.document.write('<img style="max-height:500px;max-width:500px;" src="'+ data.s3_url+'">');
      }
    },
    disableApproveRejectButton(){
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.function.toLowerCase().includes('raffle-event-winners')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.function.toLowerCase().includes('raffle-event-winners')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      if (isChe || isFortune || isAdministrator)
      {
        return false;
      } else
      {
        return true;
      }
    }
  },
  components: {
    VueBootstrap4Table,
    // BarChart,
  },
  watch: {
    PropertyFilterModel: function (val) {
      this.ConditionFilterModel = "is";
      console.log(val);
    },
    itemPerPage: function () {
      this.config.per_page = this.itemPerPage;
      this.onLoadData(this.BrandCodeModel, this.RaffleEventWinnerModel.isApprove);
    },
    currentPage: function () {
      this.onLoadData(this.BrandCodeModel, this.RaffleEventWinnerModel.isApprove);
    }
  },
};
</script>
<style></style>